import { render } from "./ChemicalViewForm.vue?vue&type=template&id=d2808c6e"
import script from "./ChemicalViewForm.vue?vue&type=script&lang=js"
export * from "./ChemicalViewForm.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ckyang/dev/olabbio/sites/olab-github/gf-olab-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__